<template>
	<div>
		<treeselect
			v-model="value"
			:options="options"
			:placeholder="placeholder"
			:alwaysOpen="alwaysOpen"
			:clearable="clearable"
			:searchable="searchable"
			:disabled="disabled"
			:default-expand-level="2"
			:show-count="true"
			:multiple="true"
			value-consists-of="LEAF_PRIORITY"
		/>
	</div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
	name: "TreeSelect",
	components: {
		Treeselect
	},
	props:{
		maxHeight: Number,
		preSlctedValue: {
			type: Array,
			default: ()=>[]
		},
		callGetValue: {
			type: Function,
			default: ()=>{}
		},
		clearable: {
			type: Boolean,
			default: true,
		},
		searchable: {
			type: Boolean,
			default: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: "Select..."
		},
		options: {
			type: Array,
			default:()=>[]
		},
		alwaysOpen: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			// define the default value
			value: null,
			// define options
		}
    },
	mounted() {
		this.setPresetValue();
	},
	watch: {
		value(newVal) {
			this.callGetValue(newVal);
		},
		preSlctedValue(newVal) {
			this.value = newVal;
		}
	},
	methods: {
		setPresetValue() {
			if (this.preSlctedValue.length > 0) {
				this.value = this.preSlctedValue;
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/common/TreeSelect.vue